import { PHASES, STAGES_P, STAGE_DONE } from './constants.js';
import { S } from './store.js';
import { daysTo, esc } from './util.js';

export const me=()=>S.users.find(u=>u.id===S.me)||S.users[0];

export const user=id=>S.users.find(u=>u.id===id)||{id:'',name:'Unassigned',color:'#8a8f9b'};

export const cli=c=>S.clients.find(x=>x.code===c);

export const cname=c=>(cli(c)||{name:c}).name;

export const pcode=p=>'#'+p.num+p.code;

export const getP=id=>S.projects.find(p=>p.id===id);

export const phase=id=>PHASES.find(p=>p.id===id);

export const fink=n=>me().perm.fin?'$'+(n/1000).toFixed(1)+'k':'$•••';

export const fin=n=>me().perm.fin?'$'+Math.round(n).toLocaleString('en-AU'):'$•••';

export const isDark=()=>S.theme==='dark'||(S.theme==='system'&&window.matchMedia&&matchMedia('(prefers-color-scheme: dark)').matches);

export const av=(id,s=26)=>{const u=user(id);return `<span class="av" style="--s:${s}px;background:${u.color}" title="${esc(u.name)}">${esc(u.name.slice(0,1))}</span>`};

export const avs=(ids,s=26)=>ids.length?`<span class="avs">${ids.slice(0,4).map(i=>av(i,s)).join('')}</span>`:'';

export function stat(p,ph){const t=p.tasks.filter(x=>x.ph===ph);return {n:t.length,d:t.filter(x=>x.status==='done').length}}

export const allDone=p=>p.tasks.length>0&&p.tasks.every(t=>t.status==='done');

export function stageOf(p){if(p.stage&&p.stage!=='auto')return STAGES_P.find(x=>x.id===p.stage)||curPhase(p);return allDone(p)?STAGE_DONE:curPhase(p)}

export const pStatus=p=>stageOf(p).id==='done'?'completed':'active';

export const curPhase=p=>PHASES.find(ph=>{const s=stat(p,ph.id);return s.n&&s.d<s.n})||PHASES[PHASES.length-1];

export const team=p=>[...new Set(p.tasks.map(t=>t.who).filter(Boolean))];

export function dueChip(due,done){if(!due||done)return '';const n=daysTo(due);if(n<0)return '<span class="chip bad">Overdue</span>';if(n===0)return '<span class="chip warn">Today</span>';return `<span class="chip">${n}d left</span>`}

export const stLabel={todo:'Not started',doing:'In progress',done:'Done'};

export function genCode(name){const w=name.replace(/[^A-Za-z0-9 ]/g,'').trim().split(/\s+/).filter(Boolean);let c=w.length>=3?w.slice(0,3).map(x=>x[0]).join(''):w.join('').slice(0,3);c=c.toUpperCase().padEnd(3,'X');let k=c,i=0;while(cli(k)){i++;k=c.slice(0,2)+String.fromCharCode(65+(i%26))}return k}
